import Vue from 'vue'
import Router from 'vue-router'
// import Survey from "../views/survey/survey.vue";
// import Education from "../views/survey/education.vue";
// import Question from "../views/survey/question.vue";
// import ThankYou from "../views/survey/thank_you.vue";

Vue.use(Router)

/* Layout */
// import Layout from '@f/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

    // {
    //   hidden: true,
    //   path: '/register',
    //   component: () => import('@f/views/users/registered'),
    //   meta: { title:'同意授權' },
    // },

    // {
    //     name: 'survey',
    //     path: '/',
    //     component: Survey,
    // },
    // {
    //     name: 'education',
    //     path: '/survey/education',
    //     component: Education,
    // },
    // {
    //     name: 'question',
    //     path: '/survey/survey',
    //     component: Question,
    // },

    // {
    //     name: 'thank_you',
    //     path: '/survey/thank-you',
    //     component: ThankYou,
    // }

]

const createRouter = () => new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router